import moment from 'moment';
import ConverterClass from '../../utils/converter';

class Converter extends ConverterClass {
    removedRequestId2Client = id => ({ emovedRequestId2: id });
}

export default new Converter();